const timeFormat: (number) => string = (timeTick: number) => {
    const date = new Date(timeTick * 1000);
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    const d = date.getDate();
    const h = date.getHours();
    const min = date.getMinutes();
    const timeStr = `${y}.${m}.${d} ${h}:${min}`;
    return timeStr;
};
type StrOrNum = string | number;
const remainingTimeFormat: (number) => string = (times: number) => {
    const d: StrOrNum = Math.floor(parseInt(`${times / 60 / 60 / 24}`, 10));
    let h: StrOrNum = parseInt(`${(times / 60 / 60) % 24}`, 10); //时
    h = h < 10 ? `0${h}` : h;
    let m: StrOrNum = parseInt(`${(times / 60) % 60}`, 10); // 分
    m = m < 10 ? `0${m}` : m;
    let s: StrOrNum = parseInt(`${times % 60}`, 10); // 当前的秒
    s = s < 10 ? `0${s}` : s;
    if (d > 0) {
        return `${d}天${h}:${m}:${s}`;
    }
    return `${h}:${m}:${s}`;
};
const timeFormatForRefundTime: (number) => string = (timeTick: number) => {
    const date = new Date(timeTick * 1000);
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    const d = date.getDate();
    const h = date.getHours();
    const min = date.getMinutes();
    const timeStr = `${y}年${m}月${d}日 ${h}:${min}`;
    return timeStr;
};
const getDay: (number) => string = (times: number) => {
    const day = String(Math.ceil(times / (3600 * 24)));
    return day;
};
export default { timeFormat, remainingTimeFormat, timeFormatForRefundTime, getDay };
